// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics-page {
  padding-bottom: 48px;
}

.statistics-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  border-bottom: 2px solid #e2e8f0;
  flex-wrap: wrap;
}

.statistics-tab {
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #718096;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
}

.statistics-tab:hover {
  color: #4a90d9;
}

.statistics-tab.active {
  color: #4a90d9;
  border-bottom-color: #4a90d9;
}

.statistics-content {
  min-height: 320px;
}

.statistics-charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 24px;
}

.statistics-chart-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.statistics-chart-card-wide {
  grid-column: 1 / -1;
}

.statistics-chart-card h3 {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 16px 0;
}

.chart-container {
  position: relative;
  height: 280px;
  width: 100%;
}

.chart-container.chart-doughnut {
  height: 300px;
  max-width: 360px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .statistics-tabs {
    gap: 4px;
  }

  .statistics-tab {
    padding: 10px 14px;
    font-size: 14px;
  }

  .statistics-charts {
    grid-template-columns: 1fr;
  }

  .chart-container {
    height: 260px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Statistics.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".statistics-page {\n  padding-bottom: 48px;\n}\n\n.statistics-tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: 24px;\n  border-bottom: 2px solid #e2e8f0;\n  flex-wrap: wrap;\n}\n\n.statistics-tab {\n  padding: 12px 20px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #718096;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s;\n}\n\n.statistics-tab:hover {\n  color: #4a90d9;\n}\n\n.statistics-tab.active {\n  color: #4a90d9;\n  border-bottom-color: #4a90d9;\n}\n\n.statistics-content {\n  min-height: 320px;\n}\n\n.statistics-charts {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));\n  gap: 24px;\n}\n\n.statistics-chart-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.statistics-chart-card-wide {\n  grid-column: 1 / -1;\n}\n\n.statistics-chart-card h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 16px 0;\n}\n\n.chart-container {\n  position: relative;\n  height: 280px;\n  width: 100%;\n}\n\n.chart-container.chart-doughnut {\n  height: 300px;\n  max-width: 360px;\n  margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n  .statistics-tabs {\n    gap: 4px;\n  }\n\n  .statistics-tab {\n    padding: 10px 14px;\n    font-size: 14px;\n  }\n\n  .statistics-charts {\n    grid-template-columns: 1fr;\n  }\n\n  .chart-container {\n    height: 260px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
